(function () {

    angular.module('tmx-app').controller('organizationsCtrl', ['$filter', 'APP_CONSTANTS', '$scope',
        '$state', '$mdSidenav', '$mdDialog', 'menu', 'OrganizationsService', 'tmxResource', 'tmxUtility', 'TmxDialogService', '$mdMedia', OrganizationsCtrl]);
    var exists;
    var copy;
    function OrganizationsCtrl($filter, APP_CONSTANTS, $scope, $state, $mdSidenav, $mdDialog, menu,
        OrganizationsService, tmxResource, tmxUtility, TmxDialogService, $mdMedia) {

        var organizationVM = this;
        organizationVM.EntityName = "Organization";
        organizationVM.menu = menu;
        
        exists = tmxUtility.exists;
        copy = tmxUtility.copy;
        organizationVM.query = "Organization";
        organizationVM.gridData = new kendo.data.ObservableArray([]);
        organizationVM.gridColumns = OrganizationsService.Columns;
        organizationVM.cols = angular.copy(organizationVM.gridColumns.slice(0, 8));
        organizationVM.reload = reload;
        organizationVM.vm = {};
        organizationVM.item = {}
        //organizationVM.gridColumns = organizationVM.Column;
        organizationVM.nav = "SearchSideNav";
        organizationVM.cloneColumn = organizationVM.Column;

        organizationVM.filters = {};
        organizationVM.checkPermission = tmxUtility.checkPermission;
        organizationVM.DialogController = DialogController;


        organizationVM.editPermission = organizationVM.checkPermission('Private.Masterdata.Organizations','Edit');

        function reload() {
            if (angular.isDefined(organizationVM.container.OrganizationGrid)) {
                organizationVM.container.OrganizationGrid.dataSource.read();
            }
        }

        function DialogController($scope, $mdDialog) {

            $scope.TotalCreditLimit = organizationVM.item.TotalCreditLimit;
            //$scope.PricelistMasterCode=pricelistVM.item.PricelistMasterCode;
            //$scope.showCodeError=true;

            $scope.hide = function () {
                $mdDialog.hide();
            };

            $scope.cancel = function () {

                $mdDialog.cancel();

            };

            $scope.ok = function (form) {
                if (angular.isDefined($scope.TotalCreditLimit)) {
                    $mdDialog.hide();
                    organizationVM.item.TotalCreditLimit = $scope.TotalCreditLimit;
                    OrganizationsService.ChangeLimit(organizationVM.item).then(function (response) {
                        reload();
                    });

                }
            };

        };
       

        organizationVM.mainGridOptions = {
            dataSource: {
                transport: {
                    read: function (o) {

                        if (angular.isDefined(organizationVM.searchClear) && organizationVM.searchClear == false) {
                            if (exists(organizationVM.o)) {
                                copy(organizationVM.o.data, ["filter"], o.data);
                            }
                        }

                        organizationVM.searchClear = false;
                        if (organizationVM.onChildState()) {
                            return;
                        }

                        if (!o.fromSideNav) {
                            if ($state.searchClear) {
                                organizationVM.searchClear = true;
                                $state.searchClear = undefined;

                            }

                        }
                        else {
                            o.data.firstPage = true;
                        }

                        organizationVM.o = angular.copy(o);
                        organizationVM.filters = organizationVM.o.data.filter;


                        // var promise=OrganizationsService.getOrganizations(o,true);
                        // promise.then(function(response){
                        tmxResource("Organization").getByParams(o, true).then(function (response) {
                            if (!angular.isDefined(response) || !angular.isDefined(response.data)) return;
                            organizationVM.kendoResponse = angular.copy(response);
                            o.success(response);
                        });
                        //return promise;
                    },

                    dataType: "json"
                },
                schema: {
                    data: "data",
                    total: "Total"
                },
                serverPaging: true,
                serverFiltering: true,
                serverSorting: true,
                sort: [{ field: "LastUpdatedDate", dir: "desc" }]
                /*  sort: [{field: "OrganizationName", dir: "desc"}] */
                // sort:  [{field: "EffectiveEndDate", dir: "desc"}/*,{field: "CreatedDate", dir: "desc"}*/],
            },
            // selectable: "multiple, row",
            pageable: {
                refresh: true,
                pageSizes: [5, 10, 15, 20, 100, 'All'],
                pageSize: 15,
                buttonCount: 5
            },
            pdf: {
                allPages: true,
                fileName: "Organization.pdf"
            },
            excel: {
                allPages: true,
                fileName: "Organization.xlsx"
            },
            excelExport: function (e) {
                var columns = e.workbook.sheets[0].columns;
                columns.forEach(function (column) {
                    delete column.width;
                    column.autoWidth = true;
                });
            },
            // filterable:true,
            sortable: true,
            scrollable: !$mdMedia('gt-sm'),         
            columns: OrganizationsService.Columns

        };
        organizationVM.container = {};
        $state.data = {
            grid: organizationVM.container,
            info: false
        };
        organizationVM.filt = {};


        organizationVM.clear = clear;
        organizationVM.search = search;
        organizationVM.getStatus = getStatus;
        organizationVM.checkAddDisabled = checkAddDisabled;
        organizationVM.onChildState = onChildState;
        organizationVM.isOpen = isOpen;
        organizationVM.new = newFunc;
        organizationVM.clickEdit = clickEdit;
        organizationVM.formatBranchCode = formatBranchCode;
        organizationVM.formatOrganizationStatus = formatOrganizationStatus;
        organizationVM.formatOrganizationNumber = formatOrganizationNumber;
        organizationVM.formatOrganizationLocation = formatOrganizationLocation;
        organizationVM.clickActive = clickActive;
        organizationVM.clickInactive = clickInactive;
        organizationVM.disableOrganization = disableOrganization;
        organizationVM.status = status;
        organizationVM.isFiltered = isFiltered;
        organizationVM.clickView = clickView;
        organizationVM.toggle = toggle;
        organizationVM.formatDataItem = formatDataItem;

        function formatDataItem(dataItem) {
            if (dataItem != null && angular.isDefined(dataItem)) {
                return dataItem;
            }
            return APP_CONSTANTS.NO_GRID_ITEM_MESSAGE;
        }

        function checkAddDisabled() {

            if ($mdSidenav(organizationVM.nav).isOpen()) {
                return true;
            }
            else {
                return false;
            }
        }

        function onChildState() {
            if ($state.current.name.indexOf(".add") > 0 || $state.current.name.indexOf(".edit") > 0 || $state.current.name.indexOf(".info") > 0 || $state.current.name.indexOf(".summary") > 0) return true;
        }

        function isOpen(navID) {
            if (organizationVM.checkPermission('masterdata.Organization.view'))
                return $mdSidenav(navID).isOpen();
        }


        function newFunc() {
            if (organizationVM.isOpen('SearchSideNav')) {
                organizationVM.toggle('SearchSideNav');
            }


            if (organizationVM.isOpen('ExportSideNav')) {
                organizationVM.toggle('ExportSideNav');
            }
            $state.data.info = false;
            localStorage.setItem("ViewState", JSON.stringify($state.data.info));
            $state.go($state.current.name + ".add");
        }

        function clickEdit(item) {
            $state.go($state.current.name + ".edit", { "Id": item.OrganizationId });
        }


        function formatBranchCode(dataitem) {
            return dataitem.CorporateDetailId;

        }

        function formatOrganizationStatus(dataitem) {

            if (dataitem.ActiveFlag == true) {
                return "Active";

            }
            else {
                return "In-Active";
            }
        }

        function formatOrganizationNumber(dataitem) {

            if (angular.isDefined(dataitem.PhoneNumber1) && dataitem.PhoneNumber1 != null) {
                return dataitem.PhoneNumber1;
            }
            else
                return APP_CONSTANTS.NO_GRID_ITEM_MESSAGE;

        }

        function formatOrganizationLocation(dataitem) {
            organizationVM.variable = APP_CONSTANTS.NO_GRID_ITEM_MESSAGE;

            if (angular.isDefined(dataitem.LocationName) && dataitem.LocationName != null) {
                organizationVM.variable = dataitem.LocationName;
                return organizationVM.variable;
            }
            else {
                return organizationVM.variable;
            }

        }


        function getBranchName(dataitem) {
            //if(angular.isDefined(dataitem.UnitName) && dataitem.UnitName!=null){
            return dataitem.CorporateName;
            //}
            //else{
            //return APP_CONSTANTS.NO_GRID_ITEM_MESSAGE;
            //}
        }

        function getContactPersonName(dataitem) {
            if (angular.isDefined(dataitem.ContactPersonName) && dataitem.ContactPersonName != null) {
                return dataitem.ContactPersonName;
            }
            else {
                return APP_CONSTANTS.NO_GRID_ITEM_MESSAGE;
            }
        }

        function getStatus(dataitem) {
            if (angular.isDefined(dataitem.Status) && dataitem.Status != null) {
                return dataitem.Status;
            }
            else {
                return APP_CONSTANTS.NO_GRID_ITEM_MESSAGE;
            }
        }

        function clickView(item) {
            $state.go($state.current.name + ".edit", { "Id": item.OrganizationId, "readOnly": true });
        }
        function isFiltered(fieldName) {

            var filtered = false;

            if (angular.isDefined(organizationVM.filters)) {
                organizationVM.filters.filters.forEach(function (filter) {
                    if (filter.field == fieldName) {
                        filtered = true;
                    }
                });
            }
            return filtered;
        }

        function status(dataitem) {

            if (dataitem.Status == "Inactive") {
                return "Inactive";
            }

            else if (dataitem.Status == "Active") {
                return "Active";

            }

        }

        function disableOrganization(dataitem) {
            if (dataitem.Status == "Active" || dataitem.Status == true) {
                return true;
            }
            else {
                return false;
            }
        }

        ////////////////////////////////////////////////////
        // Edited by Ali Ahsen Mir


        function showSummary(itemX) {

            if (organizationVM.checkPermission('masterdata.Organization.summary')) {
                //$state.data.Name = itemX.CorporateDetailId;
                //$state.data.Code = itemX.CorporateName;
                // $state.data.Type = itemX.c;
                // $state.data.Location = itemX.LocationName;
                // $state.data.ContactPerson = itemX.ContactPersonName;
                $state.go($state.current.name + ".summary", { "Id": itemX.CompanyId });
            }
        }




        ////////////////////////////////////////////////////





        function clickActive(item) {

            var diagConfig = {
                action: "Activate",
                entity: $filter('translate')("Organization"),
                entityname: item.UnitName,
                details: [
                    { value: item.UnitName, label: $filter('translate')("Name") },
                    { value: item.UnitCode, label: $filter('translate')("Code") },
                    { value: item.ContactPersonName, label: $filter('translate')("ContactPerson") }
                ],
                options: [
                    { label: $filter('translate')("Activate"), value: true, class: "md-greenery" },
                    { label: $filter('translate')("Cancel"), value: false, class: "md-primary" }
                ]
            };
            function callback(ok) {
                if (ok) {
                    organizationVM.Activate(item);
                }
            }
            var OrganizationDeactivateDialog = new TmxDialogService.confirmDialog(diagConfig, callback);

            OrganizationDeactivateDialog.show();

        }

        function clickInactive(item) {

            var diagConfig = {
                action: "Deactivate",
                entity: $filter('translate')("Organization"),
                entityname: item.UnitName,
                details: [
                    { value: item.UnitName, label: $filter('translate')("Name") },
                    { value: item.UnitCode, label: $filter('translate')("Code") },
                    { value: item.ContactPersonName, label: $filter('translate')("ContactPerson") }
                ],
                options: [
                    { label: $filter('translate')("Deactivate"), value: true, class: "md-warn" },
                    { label: $filter('translate')("Cancel"), value: false, class: "md-primary" }
                ]
            };
            function callback(ok) {
                if (ok) {
                    organizationVM.Deactivate(item);
                }
            }
            var OrganizationDeactivateDialog = new TmxDialogService.confirmDialog(diagConfig, callback);

            OrganizationDeactivateDialog.show();
        }

        organizationVM.reload = function () {
            organizationVM.container.OrganizationGrid.dataSource.read();
        };


        //*******************KENDO*********************//

        function gridDataBound(e) {
            var grid = e.sender;
            if (grid.dataSource.total() == 0) {
                var colCount = grid.columns.length;
                $(e.sender.wrapper)
                    .find('tbody')
                    .append('<tr class="kendo-data-row"><td colspan="' + colCount + '" class="no-data" style="color: #ff0100; text-align: center; vertical-align: middle;">No Data Found!</td></tr>');
            }
        }
        function toggle(navID) {

            if (navID != 'ExportSideNav' && organizationVM.isOpen('ExportSideNav')) {
                $mdSidenav('ExportSideNav')
                    .toggle()
                    .then(function () {
                    });
            }
            if (navID != 'SearchSideNav' && organizationVM.isOpen('SearchSideNav')) {
                $mdSidenav('SearchSideNav')
                    .toggle()
                    .then(function () {
                    });
            }
            if (navID != 'ImportSideNav' && organizationVM.isOpen('ImportSideNav')) {
                $mdSidenav('ImportSideNav')
                    .toggle()
                    .then(function () {
                    });
            }
            $mdSidenav(navID)
                .toggle()
                .then(function () {
                });
        }

        function search(navID) {

            var calls = [];
            for (var key in organizationVM.searchData) {
                if (organizationVM.searchData.hasOwnProperty(key)) {
                    calls.push({
                        field: key,
                        operator: "contains",
                        value: organizationVM.searchData[key]
                    });
                }
            }

            organizationVM.filt = {
                filters: calls,
                logic: "and"
            };

            organizationVM.o.data.filter = organizationVM.filt;
            organizationVM.container.OrganizationGrid.dataSource.transport.read(organizationVM.o);

            organizationVM.searchData = {};
            organizationVM.toggle(navID);
        }

        function clickCopy(item) {
            organizationVM.item.TotalCreditLimit = item.TotalCreditLimit;
            organizationVM.item.CompanyId = item.CompanyId;
            //pricelistVM.item.PricelistMasterCode =item.PricelistMasterCode;
            //pricelistVM.item.PricelistMasterId =item.PricelistMasterId;

            organizationVM.vm = item;
            $mdDialog.show({
                controller: DialogController,
                templateUrl: 'common/directives/tmxInputDialog/tmxInputDialog.html',
                parent: angular.element(document.body),
                clickOutsideToClose: true,
                fullscreen: $scope.customFullscreen // Only for -xs, -sm breakpoints.
            })
                .then(function (answer) {
                }, function () {

                });
        }

        function clear(navID) {
            organizationVM.searchData = {};
            organizationVM.toggle(navID);
        }
        function Deactivate(item) {
            item.$deactivate(item.UnitId).then(function (result) {
                organizationVM.container.OrganizationGrid.dataSource.read();
            });
        }

        function Activate(item) {
            item.$activate(item.UnitId).then(function (result) {
                organizationVM.container.OrganizationGrid.dataSource.read();
            });
        }

        function afterImport() {
            organizationVM.toggle('ImportSideNav');
            organizationVM.container.OrganizationGrid.dataSource.read();
        }
    }

})();
